module.exports = __webpack_public_path__ + "static/media/no-img.9498fe4c.png";